<div class="ai-search-result-card">

  <div class="card-content">
    <div class="card-header">
      <div class="title-row">
        <a href="#" class="card-title-link" (click)="onTitleClick($event)" [innerHTML]="displayTitle"></a>
      </div>
    </div>

    @if (formattedPublishedDate || showSender) {
    <div class="published-date">
      @if (formattedPublishedDate || showSender) {
      <span><i class="far fa-calendar-alt"></i> <span class="meta-title">Published :</span> {{ formattedPublishedDate }}</span>
        @if (showSender  && getSender()!="") {
        <span class="divider"></span>
        }
      }
      @if (showSender  && getSender()!="") {
        <span><i class="fas fa-user"></i> <span class="meta-title">Sender :</span> {{ getSender() }}</span>
      }
    </div>
    }

    <!--<p class="card-description" [innerHTML]="displayDescription"></p>-->
  </div>
</div>
